
























































































import Vue, { PropOptions } from 'vue';
// import NOC from '@/const/index' ;
import SideModalBase from '@/components/util/SideModalBase.vue';
import SearchBox from '@/components/util/SearchBox.vue';
import BasicGadget, {VUECHARTGRAPH, IGraph, CFrame} from '@/components/gadgets/BasicGadget.vue';
import * as models from '@/class/models/views/graph';
import Gadgets from '@/components/gadgets';

const MODE_LIST = 'list';
const MODE_CARD = 'card';
const MODE_DETAIL = 'detail';

const LIST_MODE_KOJIN = 'kojin';
const LIST_MODE_DEFAULT = 'default';

export interface ISettings {
  edit: boolean;
  add: boolean;
  tab: boolean;
}

export class CSettings implements ISettings {
  public edit = false;
  public add  = false;
  public tab = false;
}

export default Vue.extend({
  name: 'SideModalGadgetList',
  components: {
    SideModalBase, SearchBox, BasicGadget,
  },
  props: {
    gadgets: Array as PropOptions<models.IGadget[]>,
    settings: {
      type: Object as () => ISettings,
      default: () => new CSettings(),
    },
  },
  data() {
    return {
      title: 'a',
      mode: MODE_LIST,
      searchValue: '',
      selectGadget: {},
      dispTarget: LIST_MODE_KOJIN,
      componentGadgets: Gadgets,
      frameData: new CFrame(),
    };
  },
  computed: {
    MODE_LIST(): string { return MODE_LIST; },
    MODE_CARD(): string { return MODE_CARD; },
    MODE_DETAIL(): string { return MODE_DETAIL; },
    DISP_LIST(): models.IGadget[] {
      let returnGadgets = this.gadgets.filter((v) => (v.title.indexOf(this.searchValue) >= 0));
      // console.log(this.tab);
      if (this.settings.tab) {
        if (this.dispTarget === LIST_MODE_KOJIN) {
          returnGadgets = returnGadgets.filter((v) => (!v.default));
        } else {
          returnGadgets = returnGadgets.filter((v) => (v.default));
        }
      }

      return returnGadgets;
    },
  },
  mounted() {
    this.frameData.show = false;
    this.frameData.cover = true;
  },
  methods: {
    changeShow(mode: string) {
      this.mode = MODE_LIST;
      this.dispTarget = mode;
    },
    onClickAddEvent() {
      // this.$emit('add', this.selectIndex);
    },
    onClickGadget(select: any) {
      this.mode = MODE_DETAIL;
      this.selectGadget = select ;
    },
    onClickGadgetEdit() {
      this.$emit('edit', this.selectGadget);
    },
    onClickGadgetAdd() {
      this.$emit('add', this.selectGadget);
    },
    onDragStartGadget(gadget: models.IGadget) {
      this.$emit('holding', gadget);
    },
    onDragEndGadget() {
      this.$emit('holding', {});
    },
    getIcon(gadget: models.IGadget): string {
      // console.log(gadget);
      let src = '';
      switch (gadget.gadget) {
        case 'BasicGadget':
        case 'SampleGadget':
          for (const graph of VUECHARTGRAPH) {
            if (graph.key === gadget.data.graph[0].key) {
              src = graph.src;
            }
          }
          break;
        case 'CSVDLGadget':
          src = `\\images\\gadgets\\${gadget.gadget}2.png`;
          break;
      }
      return src;
    },
  },
});
